import { Box, Button, Flex, Group, Text } from "@mantine/core";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  cancelSubscription,
  cancelTrial,
  createSubscription,
  downgradePlan,
  forcePayment,
  updatePlan,
  upgradePlan,
} from "../../services/subscription";
import {
  dateFormat2,
  formatDate,
  isSubscriptionExpired,
  removeCookie,
  showInfo,
} from "../../utils";
import swal from "sweetalert";
import moment from "moment";
import { getProfile } from "../../services/profile";
import RoundedCheckMarkIcon from "../Svgs/RoundedCheckMarkIcon";
import useStyles from "./style";

const SettingsPackageCard = ({
  activeId,
  allPackages,
  packageId,
  title,
  price,
  plan,
  level,
  billing,
  btn,
  stripePlanId,
  duration,
  isUpgradePlan,
}) => {
  // console.log("🚀 ~ PlanCard ~ price:", price);
  // console.log("🚀 ~ PlanCard ~ activeId:", activeId);
  // console.log("plan", plan);
  // console.log("packageId", packageId);
  // console.log("packageId", packageId);
  // console.log("stripePlanId", stripePlanId);

  const { activeStaffCount } = useSelector((state) => state.staff);
  const { activePatientsCount } = useSelector((state) => state.patient);
  const { allFacilities } = useSelector((state) => state?.facility);
  console.log("🚀 ~ PlanCard ~ allFacilities:", allFacilities);
  let desc = "";
  if (price == 0)
    desc = `${plan?.staff} Staff Members, ${plan?.facility} Facility, ${plan?.patient} Patients & ${plan?.dailyUpdates} Daily Updates`;
  else
    desc = `${plan?.staff} Staff Members, ${plan?.facility} Facility, ${plan?.patient} Patients, ${plan?.notes} Notes & ${plan?.reports} Reports`;
  const { classes, cx } = useStyles();
  const [loading, setLoading] = useState(false);
  const { profile } = useSelector((state) => {
    return state?.profile;
  });
  // console.log("🚀 ~ PlanCard ~ profile:", profile);
  const isTrialActive = profile?.user?.isTrialActive;
  const isYearly = profile?.subscription?.subscriptionType === "year";
  const navigate = useNavigate();
  const icons = {
    personal: "/assets/images/personal.png",
    trial: "/assets/images/trial.png",
    agency: "/assets/images/agency.png",
  };
  const names = {
    Personal: "Silver",
    Agency: "Gold",
    Trial: "Trial",
  };

  let downgraded = false;
  let [action] = [...(profile?.subscription?.actions || [])]?.slice(-1);
  const conatinsDowngrade = action?.actionType?.includes("downgraded");
  let inPeriod = new Date() <= new Date(action?.updatedDetails?.endedAt);
  let split = action ? action?.actionType?.split(" ")?.slice(0) : [""];

  const [priceId] = split?.slice(-1);
  const downgradedTo = allPackages?.find((v) => v?.stripeId === priceId);

  if (action && conatinsDowngrade && inPeriod) downgraded = true;
  const subscriptionType = duration === "year" ? "year" : "month";

  const currentType = profile?.subscription?.subscriptionType; // "month" | "year"
  const targetType = duration === "year" ? "year" : "month";

  const isMonthToYearUpgrade = currentType === "month" && targetType === "year";

  const confirmation = (type, cancelData) => {
    if (type === "upgrade") {
      swal({
        title: `Upgrade Plan to ${title}`,
        text: `Plan Duration: ${duration}\nAmount: $ ${price}\n\nNote: Upgrade charges will be applied immediately, and a new subscription plan will take effect instantly.`,
        icon: "info",
        buttons: ["Cancel", "Upgrade Now"],
      }).then(async function (isConfirm) {
        if (isConfirm) {
          setLoading(true);
          let response = await upgradePlan({
            packageId,
            stripePlan: stripePlanId,
            upgrade: true,
            subscriptionType,
            ...(isMonthToYearUpgrade && { monthToYear: true }),
          });
          if (response) {
            setLoading(false);
            showInfo("Plan upgraded successfully.");
          } else setLoading(false);
        }
      });
    } else if (type === "downgrade") {
      // Validate facility count before downgrade
      const currentFacilityCount = allFacilities?.count || 0;
      const targetPackageFacilityLimit = plan?.facility || 0;
      const staffLimit =
        Number(plan?.staff) +
          (plan?.name === "Starter"
            ? 0
            : profile?.user?.additionalStaffCount || 0) || 0;
      const patientLimit =
        Number(plan?.patient) +
          (plan?.name === "Starter"
            ? 0
            : profile?.user?.additionalClientCount || 0) || 0;

      if (
        currentFacilityCount > targetPackageFacilityLimit ||
        activeStaffCount > staffLimit ||
        activePatientsCount > patientLimit
      ) {
        swal({
          title: "Downgrade Not Allowed",
          text: `
          You currently have more ${
            activeStaffCount > staffLimit ? "Staff," : ""
          } ${
            currentFacilityCount > targetPackageFacilityLimit
              ? "Facilities,"
              : ""
          } ${
            activePatientsCount > patientLimit ? "Clients" : ""
          } than this downgraded package supports. Please deactivate any non active ${
            activeStaffCount > staffLimit ? "Staff," : ""
          } ${
            currentFacilityCount > targetPackageFacilityLimit
              ? "Facilities,"
              : ""
          } ${
            activePatientsCount > patientLimit ? "Clients" : ""
          } to allow for this downgrade
          `,
          icon: "warning",
          buttons: ["Cancel", "OK"],
        });
        return;
      }

      // Validate staff count before downgrade
      // const currentStaffCount = allStaff?.length || 0;
      // const targetPackageStaffLimit = plan?.staff || 0;

      // if (currentStaffCount > targetPackageStaffLimit) {
      //   swal({
      //     title: "Downgrade Not Allowed",
      //     text: `You currently have ${currentStaffCount} staff ${currentStaffCount === 1 ? 'member' : 'members'}, but this plan only supports ${targetPackageStaffLimit}. Please remove any non-active staff members to allow for this downgrade.`,
      //     icon: "warning",
      //     buttons: ["OK"],
      //   });
      //   return;
      // }
      swal({
        // \n(Payment due at the end of the active subscription period)
        // title: `Downgrade Plan to ${names[title]}`,
        title: `Downgrade Plan to ${title}`,
        text: `Plan Duration: ${duration}\nAmount: $ ${price}\n\nNote: This subscription is recurring downgrading a subscription will kick in the following subscription period.`,
        icon: "info",
        buttons: ["Cancel", "Downgrade Now"],
      }).then(async function (isConfirm) {
        if (isConfirm) {
          setLoading(true);
          let response = await downgradePlan({
            packageId,
            stripePlan: stripePlanId,
            upgrade: false,
            subscriptionType,
          });
          if (response) {
            showInfo(
              "Plan downgraded successfully. \nPayment due at the end of the active subscription period.",
            );
            setLoading(false);
          } else setLoading(false);
        }
      });
    } else if (type === "trial") {
      swal({
        // \n(Payment due at the end of the active subscription period)
        // title: `Downgrade Plan to ${names[title]}`,
        title: `You are currently on a free trial`,
        text: `Would you like to subscribe to the ${title} plan now?`,
        icon: "info",
        buttons: ["Cancel", "Subscribe Now"],
      }).then(async function (isConfirm) {
        if (isConfirm) {
          setLoading(true);
          let obj = {
            packageId: packageId,
            stripePlanId: stripePlanId,
            email: profile?.user?.email,
            userId: profile?.user.id,
            businessId: profile?.business?.id,
            stripeCustomerId: profile?.subscription?.stripeCustomerId,
            forcefully: true,
            subscriptionType,
          };
          console.log("🚀 ~ confirmation ~ obj:", obj);
          let response = await createSubscription(obj, null, "automatic");
          if (response) {
            getProfile();
            showInfo("Plan successfully.");
            setLoading(false);
          } else setLoading(false);
        }
      });
    } else if (type === "cancel-trial") {
      swal({
        title: `Cancel Trial Subscription Plan`,
        text: `Are you sure you want to cancel this trial subscription?`,
        icon: "info",
        dangerMode: true,
        buttons: ["Cancel", "Cancel Trial"],
      }).then(async function (isConfirm) {
        if (isConfirm) {
          setLoading(true);
          let response = await cancelTrial(cancelData);
          if (response.status === 200) {
            removeCookie("token");
            navigate("/");
            setLoading(false);
          } else setLoading(false);
        }
      });
    } else {
      swal({
        title: `Cancel Subscription "${title}" Plan`,
        text: `Are you sure you want to cancel this subscription?`,
        icon: "info",
        dangerMode: true,
        buttons: ["Cancel", "Cancel Subscription"],
      }).then(async function (isConfirm) {
        if (isConfirm) {
          setLoading(true);
          let response = await cancelSubscription(cancelData);
          if (response.status === 200) {
            removeCookie("token");
            navigate("/");
            setLoading(false);
          } else setLoading(false);
        }
      });
    }
  };

  // console.log('downgraded', downgraded);

  const onClick = async () => {
    if (isTrialActive) {
      confirmation("trial");
      return;
    }
    if (Number(activeId?.cost) === 0) {
      navigate("/payInfo", {
        state: {
          planId: packageId,
          stripePlan: stripePlanId,
          plan,
        },
      });
    } else {
      // if (Number(level) > Number(activeId?.level)) {
      if (
        Number(level) < Number(activeId?.level) &&
        activeId?.duration === "month" &&
        duration === "year"
      ) {
        confirmation("downgrade");
      } else if (Number(price) > Number(activeId?.cost)) {
        confirmation("upgrade");
      } else {
        confirmation("downgrade");
      }
    }
  };
  const cancelSub = async () => {
    if (isTrialActive) {
      confirmation("cancel-trial", {
        _id: profile?.subscription?.id,
        stripeSubscriptionId: profile?.subscription?.stripeSubscriptionId,
      });
    } else {
      confirmation("cancel-subscription", {
        _id: profile?.subscription?.id,
        stripeSubscriptionId: profile?.subscription?.stripeSubscriptionId,
      });
    }
  };
  const reNewSubscription = async () => {
    await forcePayment();
  };

  if (price == 0 && activeId?.cost != 0) return null;
  const isDowngrade = Number(price) < Number(activeId?.cost);
  const disableMonthlyForYearlyUser =
    isYearly && (duration === "month" || isDowngrade);

  // if( plan?.general === false && plan?.users?.includes(profile?.user?.id) === false ) return null
  return (
    <Box
      className={
        activeId?.id == packageId
          ? cx(classes.pkgCard, classes.activePkgCard)
          : classes.pkgCard
      }
    >
      <Box>
        <Flex className={classes.pkgNameRow}>
          <p>
            {title}
            {title === "Bronze" && (
              <img src="/assets/images/bronze-medal.png" />
            )}
            {title === "Silver" && (
              <img src="/assets/images/silver-medal.png" />
            )}
            {title === "Gold" && <img src="/assets/images/gold-medal.png" />}
          </p>
          {isTrialActive && (activeId?.id == packageId ? <p>Trial</p> : null)}
        </Flex>
        <p className={classes.pkgPrice}>
          ${price}
          <span>/{duration}</span>
        </p>
      </Box>
      <Box
        className={cx(
          classes.pkgBottomContent,
          isUpgradePlan && classes.upgradePlanBgColor,
        )}
      >
        <Box
          className={cx(
            classes.desAndDetailsBox,
            isUpgradePlan && classes.upgradePlanList,
          )}
        >
          <Flex className={classes.listParent}>
            <p>
              <RoundedCheckMarkIcon color={isUpgradePlan && "#9E77ED"} />
              {plan?.staff} Staff Members
            </p>
            <p>
              <RoundedCheckMarkIcon color={isUpgradePlan && "#9E77ED"} />
              {plan?.facility} Facility
            </p>
            <p>
              <RoundedCheckMarkIcon color={isUpgradePlan && "#9E77ED"} />
              {plan?.patient} Patients
            </p>
            {price == 0 ? (
              <>
                <p>
                  <RoundedCheckMarkIcon color={isUpgradePlan && "#9E77ED"} />
                  {plan?.dailyUpdates} Daily Updates
                </p>
              </>
            ) : (
              <>
                <p>
                  <RoundedCheckMarkIcon color={isUpgradePlan && "#9E77ED"} />
                  {plan?.notes} Notes & {plan?.reports} Reports
                </p>
              </>
            )}
          </Flex>
          {activeId?.id == packageId ? (
            <Text>
              {price != 0 && (
                <Text className={classes.billing}>
                  {isTrialActive ? "Trial Cycle :" : "Billing Cycle : "}
                  <span className={classes.cycle}>{billing}</span>
                </Text>
              )}
              {downgraded ? (
                <div className={classes.cycle} style={{ color: "#979797a0" }}>
                  {`You have downgraded this Plan to ${
                    // names[downgradedTo?.name]
                    downgradedTo?.name
                  }
                . Changes will reflect by the end of this period.`}
                </div>
              ) : null}
            </Text>
          ) : null}
        </Box>
        {activeId?.id != packageId && (
          <Button
            loading={loading}
            onClick={onClick}
            className={cx(
              classes.selectBtn,
              isUpgradePlan && classes.upgradeBtn,
            )}
            loaderProps={{ color: "black" }}
            // disabled={downgraded && btn === "Select Plan"}
            disabled={disableMonthlyForYearlyUser}
          >
            {isTrialActive ? "Subscribe Plan" : btn}
          </Button>
        )}
        {activeId?.id == packageId&& (
          <Button
            // loading={loading}
            // onClick={cancelSub}
            className={classes.cancelSubBtn}
            disabled
          >
            Currently Active
          </Button>
        )}
        {activeId?.id == packageId && Number(activeId?.cost) !== 0 && (
          <Button
            loading={loading}
            onClick={cancelSub}
            className={classes.cancelSubBtn}
          >
            {isTrialActive ? "Cancel Trial" : "Cancel Subscription"}
          </Button>
        )}
        {activeId?.id == packageId && isSubscriptionExpired() && price != 0 && (
          <Button
            loading={loading}
            onClick={reNewSubscription}
            className={classes.selectBtn}
          >
            Renew Subscription
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default SettingsPackageCard;
